import {action, makeObservable, toJS} from 'mobx'
import {AdvertiserService as Service} from 'rest/services/AdvertiserService'
import {Stores} from './index'
import {AdvertiserDto} from 'rest/models/AdvertiserDto'

export class AdvertiserStore {
  stores: Stores
  _advertiser: AdvertiserDto

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      getAdvertiserBySourceId: action,
    })
  }

  get advertiser() {
    // if (localStorage.getItem('advertiser') !== 'undefined') {
    //   this._advertiser = JSON.parse(localStorage.getItem('advertiser'))
    // }
    return toJS(this._advertiser)
  }

  getAdvertiserBySourceId = async (): Promise<any> => {
    try {
      const res = await Service.getApiAdvertiserGetBySourceId(
        this.stores.AuthStore.me.id
      )
      this._advertiser = res.data
      // localStorage.setItem('advertiser', JSON.stringify(this._advertiser))
      return res.data
    } catch (err) {
      console.log({err})
      if (err.status === 401) throw err
      else this.stores.ErrorStore.handle(err)
    }
  }
}
